import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Car, Phone, Check, Shield, Clock, Key } from "lucide-react";
import { Button } from "@/components/ui/button";

const PHONE_NUMBER = "306-262-5995";

const AutomotivePage = () => {
  const services = [
    { title: "Car Lockouts", desc: "Locked your keys in the car? We'll get you back on the road fast." },
    { title: "Key Programming", desc: "Programming for transponder keys, smart keys, and remotes." },
    { title: "Transponder Keys", desc: "Cut and program new transponder keys for your vehicle." },
    { title: "Ignition Repair", desc: "Fix stuck or damaged ignitions - repair or replacement." },
    { title: "Key Fob Replacement", desc: "Lost your key fob? We can replace and program new ones." },
    { title: "Broken Key Extraction", desc: "Key broke in the lock or ignition? We'll extract it safely." },
  ];

  const brands = ["Toyota", "Honda", "Ford", "Chevrolet", "Dodge", "Nissan", "Hyundai", "Kia", "BMW", "Mercedes", "Audi", "Volkswagen"];

  return (
    <div className="min-h-screen bg-slate-900">
      <Header />
      
      {/* Hero */}
      <section className="pt-32 pb-20 px-4 md:px-8 relative">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1449965408869-eaa3f722e40d')] bg-cover bg-center opacity-20"></div>
        <div className="max-w-7xl mx-auto text-center relative z-10">
          <div className="inline-flex items-center gap-2 bg-blue-900/80 border border-blue-700 rounded-sm px-6 py-3 mb-6">
            <Car className="w-6 h-6 text-amber-400" />
            <span className="text-white font-semibold text-lg">Automotive Services</span>
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl text-white mb-6">
            Car Locksmith <span className="text-amber-400">Saskatoon</span>
          </h1>
          <p className="text-slate-300 text-lg max-w-2xl mx-auto mb-8">
            Locked out of your car? Lost your keys? We service all vehicle makes and models with fast, mobile service.
          </p>
          <a href={`tel:${PHONE_NUMBER.replace(/-/g, "")}`}>
            <Button className="bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold text-lg px-8 py-6">
              <Phone className="w-5 h-5 mr-2" />
              Call Now: {PHONE_NUMBER}
            </Button>
          </a>
        </div>
      </section>

      {/* Services */}
      <section className="py-20 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-3xl text-white text-center mb-12">Our Automotive Services</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, idx) => (
              <div key={idx} className="bg-slate-800 border border-slate-700 rounded-sm p-6">
                <div className="w-12 h-12 bg-amber-500/20 rounded-sm flex items-center justify-center mb-4">
                  <Check className="w-6 h-6 text-amber-400" />
                </div>
                <h3 className="text-white font-bold text-xl mb-2">{service.title}</h3>
                <p className="text-slate-400">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Brands */}
      <section className="py-20 px-4 md:px-8 bg-slate-800">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-3xl text-white text-center mb-4">All Makes & Models</h2>
          <p className="text-slate-400 text-center mb-12">We service all vehicle brands including:</p>
          <div className="grid grid-cols-3 md:grid-cols-6 gap-4">
            {brands.map((brand, idx) => (
              <div key={idx} className="bg-slate-700 rounded-sm p-4 text-center">
                <p className="text-white font-medium">{brand}</p>
              </div>
            ))}
          </div>
          <p className="text-slate-500 text-center mt-6">+ Many More!</p>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 md:px-8 bg-amber-500">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-3xl text-slate-900 mb-4">Locked Out of Your Car?</h2>
          <p className="text-slate-700 text-lg mb-8">We come to you! Mobile service across Saskatoon.</p>
          <a href={`tel:${PHONE_NUMBER.replace(/-/g, "")}`}>
            <Button className="bg-slate-900 hover:bg-slate-800 text-white font-bold text-xl px-10 py-6">
              <Phone className="w-6 h-6 mr-3" />
              {PHONE_NUMBER}
            </Button>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AutomotivePage;
